export default __webpack_public_path__ + "static/media/g3.fb23fa18.jpg";